import { render, staticRenderFns } from "./AccettazioneSsnListaComponent.vue?vue&type=template&id=f5c56030&scoped=true"
import script from "./AccettazioneSsnListaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnListaComponent.vue?vue&type=style&index=0&id=f5c56030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c56030",
  null
  
)

export default component.exports